import React, { useState } from 'react';
import { ARTICLE, TINTS } from '../../data/mock';
import { HealthBuddy } from '../HealthBuddy';
import { PlayIcon, PauseIcon, CheckIcon, BookIcon } from '../icons';

/**
 * Educational article reader — curated content with optional narration.
 * When narration plays, the buddy "speaks" (mock of Rive lip-sync + ElevenLabs).
 */
export function ArticleModal() {
  const [playing, setPlaying] = useState(false);
  return <div className="px-5 pb-10 pt-2" data-id="element-301">
      {/* header */}
      <span className="inline-flex items-center gap-1.5 rounded-full bg-teal-soft px-3 py-1 text-[11px] font-bold uppercase tracking-[0.1em] text-teal-deep" data-id="element-302">
        <BookIcon size={12} data-id="element-303" />
        {ARTICLE.category}
      </span>
      <h2 className="font-display mt-2.5 pr-20 text-[24px] font-semibold leading-tight text-ink" data-id="element-304">{ARTICLE.title}</h2>
      <p className="mt-1.5 text-[12.5px] font-semibold text-ink-faint" data-id="element-305">{ARTICLE.minutes} min read · reviewed by your care team</p>

      {/* narration player */}
      <div className="mt-4 flex items-center gap-3 rounded-card bg-teal p-3.5" data-id="element-306">
        <HealthBuddy size={44} mood={playing ? 'speaking' : 'idle'} data-id="element-307" />
        <div className="min-w-0 flex-1" data-id="element-308">
          <p className="text-[13px] font-bold text-cream" data-id="element-309">{playing ? 'Sunny is reading…' : 'Listen instead?'}</p>
          <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-teal-deep" data-id="element-310">
            <div className="h-full rounded-full bg-butter transition-all duration-1000" style={{
            width: playing ? '38%' : '0%'
          }} data-id="element-311" />
          </div>
          <p className="mt-1 text-[11px] font-semibold text-teal-soft" data-id="element-312">{playing ? '1:08 / 2:54' : 'Narrated by Sunny · 2:54'}</p>
        </div>
        <button onClick={() => setPlaying(p => !p)} className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-cream text-teal-deep shadow-card transition-transform hover:scale-105 active:scale-95" data-id="element-313">
          {playing ? <PauseIcon size={18} data-id="element-314" /> : <PlayIcon size={18} data-id="element-315" />}
        </button>
      </div>

      {/* key points */}
      <div className="mt-4 rounded-card border border-[#7E9E7833] bg-sage-soft p-4" data-id="element-316">
        <h3 className="text-[11px] font-bold uppercase tracking-[0.14em] text-sage-deep" data-id="element-317">The short version</h3>
        <ul className="mt-2.5 flex flex-col gap-2" data-id="element-318">
          {ARTICLE.keyPoints.map(point => <li key={point} className="flex items-start gap-2.5 text-[13.5px] font-medium leading-snug text-ink" data-id="element-319">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage text-cream" data-id="element-320">
                <CheckIcon size={11} strokeWidth={2.5} data-id="element-321" />
              </span>
              {point}
            </li>)}
        </ul>
      </div>

      {/* body */}
      <div className="mt-5 flex flex-col gap-4" data-id="element-322">
        {ARTICLE.paragraphs.map((para, i) => <p key={i} className="text-[14.5px] leading-relaxed text-ink-soft first:text-ink" data-id="element-323">
            {para}
          </p>)}
      </div>

      {/* related — semantic discovery continues */}
      <h3 className="font-display mt-7 text-[16px] font-semibold text-ink" data-id="element-324">Keep exploring</h3>
      <div className="mt-2.5 flex flex-col gap-2" data-id="element-325">
        {ARTICLE.related.map(rel => {
        const tint = TINTS[rel.tint];
        return <button key={rel.title} className={`flex items-center justify-between rounded-2xl border ${tint.border} ${tint.soft} px-4 py-3.5 text-left transition-transform hover:-translate-y-0.5 active:scale-[0.98]`} data-id="element-326">
              <span className="text-[14px] font-semibold text-ink" data-id="element-327">{rel.title}</span>
              <span className={`text-[12px] font-bold ${tint.text}`} data-id="element-328">{rel.minutes} min</span>
            </button>;
      })}
      </div>
    </div>;
}